import React from 'react';

const SearchForm = ({ idVentaBuscar, setIdVentaBuscar, onBuscar, loading }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-6 mb-6 border border-gray-100">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-lg bg-gray-100">
          <span className="text-gray-700 text-xl">🔍</span>
        </div>
        <div>
          <h2 className="text-lg font-medium text-gray-900">Buscar Venta</h2>
          <p className="text-gray-600 text-sm">Ingresa el ID de la venta para comenzar el proceso de devolución</p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-3">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">ID de la Venta</label>
          <input
            type="number"
            value={idVentaBuscar}
            onChange={(e) => setIdVentaBuscar(e.target.value)}
            placeholder="Ej: 123"
            className="w-full px-4 py-3 border rounded-lg focus:border-gray-400 transition-all duration-150 text-lg"
            disabled={loading}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && idVentaBuscar) {
                onBuscar(idVentaBuscar);
              }
            }}
          />
        </div>
        <div className="flex items-end">
          <button
            onClick={() => onBuscar(idVentaBuscar)}
            className="px-6 py-3 bg-gray-900 text-white rounded-lg disabled:opacity-50"
            disabled={loading || !idVentaBuscar}
          >
            {loading ? 'Buscando...' : 'Buscar Venta'}
          </button>
        </div>
      </div>

      <div className="mt-4 p-3 bg-gray-50 rounded">
        <p className="text-sm text-gray-600">
          <strong>💡 Consejo:</strong> Puedes encontrar el ID de venta en el historial de ventas o en el ticket impreso.
        </p>
      </div>
    </div>
  );
};

export default SearchForm;
